<script lang="ts">
    import { _ } from "svelte-i18n"
    import { breadcrumbs, location } from "../../store"
    import SiteNavSub from "./SiteNavSub.svelte"
    import { categoryPathMap } from "../../store"
    import { langField } from "../../i18n"

    let innerWidth: number
</script>

<svelte:window bind:innerWidth="{innerWidth}" />

{#if $breadcrumbs.length}
    <div class="firstheadline">
        <h2>
            {#if innerWidth > 1050}
                {langField($breadcrumbs[0].name, "")}
            {:else}
                {$categoryPathMap[$location?.categoryPath]
                    ? langField($categoryPathMap[$location?.categoryPath].name, "")
                    : $_("site-nav.all-products")}
            {/if}
        </h2>
    </div>

    {#if innerWidth > 1050}
        <div id="sitenav">
            <ul>
                {#each $breadcrumbs[0].childObjects as node}
                    <li class:active="{$breadcrumbs.length >= 2 && $breadcrumbs[1] == node}">
                        <a href="{langField(node.path, '')}">{langField(node.name, "")}</a>
                        {#if node.childObjects?.length}
                            <SiteNavSub level="{2}" nodes="{node.childObjects}" />
                        {/if}
                    </li>
                {/each}
            </ul>
        </div>
    {/if}
{/if}

<style lang="less">
    @import "../../css/variables.less";

    .firstheadline {
        height: 60px;
        border-bottom: 1px dashed var(--border-color-2);
        .flex();
        justify-content: flex-end;
        flex-direction: column;
        padding-bottom: 10px;
        margin-bottom: 20px;
        h2 {
            margin: 0px;
            font-size: 1.8rem;
        }
    }
</style>
